<template>
    <div class="upgrade-box">
        <el-row class="upgrade-box-bg">
            <el-row class="upgrade-box-title">
                <h2>什么是<span>专升本？</span></h2>
                <p>
                	专升本考试是指专科层次学生进入本科层次阶段学习的选拔考试，采用3+2模式，是中国大陆<br>应试教育体制，跟普通高考直接进入本科大学的相比，专升本是由普通高考进入专科学习，并<br>继续升学进行本科选拔考试，进入本科院校深造的渠道，是大专毕业生的第二条路。<br> 专升本分为两种类型。一类是普通高等学校的普通高等教育的专升本(即普通全日制本科)，考<br>试对象仅限于各省和各直辖市的普通高等学校的普通全日制专科应届毕业生。另一类是报名参<br>加成人高考的成人高等学校(脱产)或者报名参加成人高考的成人高等教育的专升本(分为业余和<br>函授两种)。
                </p>
                <img src="@/assets/images/upgrade_student.png">
            </el-row>
         	<el-row class="upgrade-box-tips-bg" v-if="provinceCode === '41'">
	            <el-row class="upgrade-box-common upgrade-box-tips-list upgrade-box-common1">
	            <h3>
	                <span class="high-box-arrow-right"></span>
	                招生流程
	                <span class="high-box-arrow-left"></span>
	            </h3>
	                <el-row class="upgrade-box-tips-time">
	                    <img src="@/assets/images/upgrade_img3.png">
	                </el-row>
	                <el-row class="upgrade-box-tips" type="flex">
	                    <div class="upgrade-box-tips-item2 upgrade-box-tips-item-common1 upgrade-box-tips-item-common">
	                        <div class="upgrade-box-tips-content">
	                            <span>11月底</span><br>
	                            网上报名及信息采集
	                        </div>
	                    </div>
	                    <div class="upgrade-box-tips-item3 upgrade-box-tips-item-common1">
	                        <div class="upgrade-box-tips-content">
	                            <span>3月</span><br>
	                            准考证打印
	                        </div>
	                    </div>
	                    <div class="upgrade-box-tips-item4 upgrade-box-tips-item-common1 upgrade-box-tips-item-common">
	                        <div class="upgrade-box-tips-content">
	                            <span>4月上旬</span><br>
	                            专升本考试
	                        </div>
	                    </div>
	                    <div class="upgrade-box-tips-item5 upgrade-box-tips-item-common1">
	                        <div class="upgrade-box-tips-content">
	                            <span>4月下旬</span><br>
	                            成绩公布
	                        </div>
	                    </div>
	                    <div class="upgrade-box-tips-item6 upgrade-box-tips-item-common1 upgrade-box-tips-item-common">
	                        <div class="upgrade-box-tips-content">
	                            <span>4月下旬-5月上旬</span><br>
	                            志愿填报和录取结果
	                        </div>
	                    </div>
	                     <div class="upgrade-box-tips-item7 upgrade-box-tips-item-common1">
	                        <div class="upgrade-box-tips-content">
	                            <span>9月</span><br>
	                            报到上学
	                        </div>
	                    </div>
	                </el-row>
	            </el-row>
	        </el-row>
	        <el-row class="upgrade-box-tips-bg upgrade-box-tips-bg-diff" v-if="provinceCode === '51'">
	            <el-row class="upgrade-box-common upgrade-box-tips-list upgrade-box-common1">
	            <h3>
	                <span class="high-box-arrow-right"></span>
	                招生流程
	                <span class="high-box-arrow-left"></span>
	            </h3>
	                <el-row class="upgrade-box-tips-time">
	                    <img src="@/assets/images/upgrade_img3.png">
	                </el-row>
	                <el-row class="upgrade-box-tips" type="flex">
	                    <div class="upgrade-box-tips-item2 upgrade-box-tips-item-common1 upgrade-box-tips-item-common">
	                        <div class="upgrade-box-tips-content">
	                            <span>3月</span><br>
	                            网上报名及志愿填报
	                        </div>
	                    </div>
	                    <div class="upgrade-box-tips-item3 upgrade-box-tips-item-common1">
	                        <div class="upgrade-box-tips-content">
	                            <span>4月</span><br>
	                            专升本考试
	                        </div>
	                    </div>
	                    <div class="upgrade-box-tips-item1 upgrade-box-tips-item-common1 upgrade-box-tips-item-common">
	                        <div class="upgrade-box-tips-content">
	                            <span>5月</span><br>
	                            成绩及录取结果公布
	                        </div>
	                    </div>
	                     <div class="upgrade-box-tips-item5 upgrade-box-tips-item-common1">
	                        <div class="upgrade-box-tips-content">
	                            <span>9月</span><br>
	                            报到上学
	                        </div>
	                    </div>
	                </el-row>
	            </el-row>
	        </el-row>
        </el-row>
        <el-row v-if="has_code == 1" class="upgrade-box-school upgrade-box-common">
		    <h3>
		        <span class="high-box-arrow-right"></span>
		            专升本学校
		        <span class="high-box-arrow-left"></span>
		    </h3>
		    <div class="upgrade-box-school-infor">
		        <div class="upgrade-box-school-input"> 
		            <el-input v-model="search.scl_name" @keyup.enter.native="searchData" placeholder="搜索学校">
		            <template slot="append">
		                <img @click="searchData" src="../../assets/images/sousuo.png" alt="搜索">
		            </template>
		        </el-input>
		        </div>
		        <div class="upgrade-box-school-content" v-if="requestStatus === '3'">
		        	<el-row :gutter="27">
		        		<el-col :span="6" v-for="(item, index) in schoolList" :key="index">
		        			<div class="upgrade-box-school-item" @click="schoolDetailHandler(item.scl_id)">
		        				<img :src="item.logo" @error="nofindImg(index)">
		        				<div>{{item.scl_name}}</div>
		        			</div>
		        		</el-col>
		        	</el-row>
		           
		        </div>
		         <div class="no-data-box" v-else-if="requestStatus === '2'">
		            <img src="../../assets/images/null.png" alt="没有数据">
		            <p>暂无数据</p>
		        </div>
		        <el-pagination background layout="prev, pager, next, jumper" :total="total" :page-size="20" @current-change="getSchoolListHandler" :current-page.sync="currentPage" v-if="requestStatus === '3'">
		        </el-pagination>
		    </div>
		</el-row>
        <el-row class="upgrade-box-question upgrade-box-common upgrade-box-common1">
            <h3>
                <span class="high-box-arrow-right"></span>
                专升本常见问题解答
                <span class="high-box-arrow-left"></span>
            </h3>
            <el-collapse class="upgrade-box-question-list">
              <el-collapse-item v-for="(item, index) in questionList" :key="index" :title="item.title" :name="index">
                <div v-html="item.desc" />
              </el-collapse-item>
            </el-collapse>
        </el-row>
        <div class="upgrade-box-nan">
	        <el-row class="upgrade-box-common upgrade-box-common1">
	            <h3>
	                <span class="high-box-arrow-right"></span>
	                报考难点
	                <span class="high-box-arrow-left"></span>
	            </h3>
	            <img src="../../assets/images/upgrade-nan-img.png">
	            <el-row style="margin-top: 64px;margin-bottom: -90px;">
	                <el-row class="upgrade-box-nan-list">
	                    <el-col class="upgrade-box-nan-item" style="margin-right: 154px">
	                        难在信息获取难
	                    </el-col>
	                    <el-col class="upgrade-box-nan-item" style="margin-left: 154px">
	                        难在专业不知如何确定
	                    </el-col>
	                </el-row>
	                <el-row class="upgrade-box-nan-list">
	                    <el-col class="upgrade-box-nan-item" style="margin-right: 154px">
	                        难在不知升本趋势如何
	                    </el-col>
	                    <el-col class="upgrade-box-nan-item" style="margin-left: 154px">
	                        难在不会做复习规划
	                    </el-col>
	                </el-row>
	            </el-row>
	        </el-row>
	        <el-row class="upgrade-box-service-diff upgrade-box-common upgrade-box-common1">
	            <el-row class="upgrade-box-infor upgrade-box-order">
	                <img src="../../assets/images/channel-order.png" alt="">
	                <div>
	                    <span class="upgrade-box-order-title">预约专家 免费咨询</span>
	                    <span class="upgrade-box-order-desc">留下联系方式，立即与专家一对一</span>
	                </div>
	                <el-row>
	                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
	                        <el-form-item label="姓名：" prop="username">
	                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
	                        </el-form-item>
	                        <el-form-item label="电话：" prop="phone">
	                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
	                        </el-form-item>
	                        <el-form-item>
	                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
	                        </el-form-item>
	                    </el-form>
	                </el-row>
	            </el-row>
	        </el-row>
       </div>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
import { getSchoolList } from '@/api/upgrade'
import { mapState } from "vuex"

export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        return {
            questionList: [{
                title:'能否跨省考试?',
                desc:'<p>普通高校的专升本考试通常只招收省内普通高等院校应届普通高职高专的优秀毕业生。也就是说，如果你在四川上大学，就只能在四川进行统招专升本。</p>'
            },{
                title:'考上本科后，毕业后第一学历(全日制学历)是本科还是专科?',
                desc:'<p>专科学生接入本科毕业后的第一学历是本科。</p>'
            },{
                title:'报考专升本的同学还有专科毕业证吗?',
                desc:'<p>专科学生升入本科后，需要拿专科毕业证到本科院校报到。<p>'
            },{
                title:'普通高校专升本的考生毕业证和正常的本科生毕业证有区别么?',
                desc:'<p>按国家规定专升本学生入学后，按本科院校学生学籍进行管理。毕业后由学校统一颁发毕业证书，其毕业证书内容填写“在我校XX专业专科起点本科学习”，学习起止时间按接入本科实际时间填写。学习期满且成绩合格的学生，可根据《中华人民共和国学位条例》及有关规定申请授予相应的学士学位。学生毕业时，按国家有关本科毕业生的就业政策执行。</p>'
            },{
                title:'专升本证书是发函授证吗?专升本学历是第一学历吗?',
                desc:'<p>专科升入本科后，所发的证书是普通高等教育的本科毕业证书，并且第一学历为本科。(也就是说，与普通的本科生一样)。</p>'
            },{
                title:'专升本以后收取的学费和其他本科生一样么?',
                desc:'<p>根据国家规定专升本学生入学后，按本科院校学生学籍进行管理，其各项收费按升入学校的本科同专业学生收费标准收取。</p>'
            },{
                title:'专升本有啥好处?',
                desc:'<p>1、第一学历提升：专升本后毕业拿到的本科证是作为第一学历使用的，是所有提升学历方式中含金量最高的。毕业后能够获得学士学位，学信网上的档案也会显示第一学历全日制本科。<br>2、可以更好的就业：许多单位(尤其是国家机关和事业单位)招聘都要求本科或硕士以上学历，专科没有应聘或考试资格。<br>3、考研升学：专插本毕业还可以继续升学，可以像本科生一样直接报考全国统招研究生。虽然政策规定专科生毕业两年后能以同等学力报考研究生，但许多大学都不招收同等学力考生。</p>'
            }],
            formInline: {
                username: '',
                phone: '',
                type: '15'
            },
            search: {
                scl_name: ''
            },
            schoolList: [],
            currentPage: 1,
            total: 0,
            requestStatus: '1',
            has_code: 0,
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
            }
        };
    },

    computed: {
        ...mapState({
            provinceCode: state => state.user.provinceCode,
            function_code: state => state.user.function_code
        }),
    },

    watch: {
        provinceCode(newVal) {
            this.schoolList = []
            this.currentPage = 1
            this.totalData = 0
            this.getSchoolListHandler()
        },
        function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00023'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }
    },

    mounted() {
        const tmp = this.function_code.filter(item => { return item.function_code === 'F00023'})
        if(tmp.length > 0) {
            this.has_code = tmp[0].has_code
        }
        this.getSchoolListHandler()
    },

    methods: {
        searchData() {
            this.currentPage = 1
            this.getSchoolListHandler()
        },
        getSchoolListHandler() {
            getSchoolList(this.search, this.provinceCode, this.currentPage).then(res => {
                const data = res.data
                if(data.total === 0) {
                    this.requestStatus = '2'
                    return
                }
                this.requestStatus = '3'
                this.schoolList = res.data.data
                this.schoolList.map(item => {
                	item.logo = 'https://gaokao.zmpajx.com/pic/'+item.scl_id+'.jpg';
                })
                this.total = data.total
            })
        },
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        },
        nofindImg(index) {
            this.schoolList[index].logo = require("../../assets/images/scl_default.png");
		},
		schoolDetailHandler(scl_id) {
			this.$router.push({
				path:'/schoolDetail',
                query: {
                    scl_id: scl_id
                }
			})
		}
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
@font-face {
    font-family: 'Impact';
    src: url('../../assets/fonts/Impact.ttf');
}
@font-face {
    font-family: 'zihun443hao';
    src: url('../../assets/fonts/zihun443hao.ttf');
}
$width: 1200px;
$margin: 0 auto;
$font-family: 'MicrosoftYaHei';
.upgrade-box {
	margin-bottom: -56px;
}
.upgrade-box-bg {
    background: url('../../assets/images/upgrade_bg.png') no-repeat;
    background-size: cover;
    .upgrade-box-title {
        margin: 82px auto;
        @include gwidth;
        position: relative;
        h2 {
            font-family: $font-family;
            font-weight: 700;
            margin: 0;
            font-size: 56px;
            margin-top: 92px;
        	color: #ffffff;
        	line-height: 74px;
			letter-spacing: 4px;
        }
        span {
        	color: #FFFB6C;
        }
        p {
        	font-size: 16px;
        	font-weight: 400;
			color: #ffffff;
			line-height: 32px;
			margin-top: 37px;
			margin-bottom: 85px;
        }
        img {
        	position: absolute;
        	top: 10px;
        	right: 0;
        }
    }
}
.upgrade-box-infor {
    height: 314px;
    background: rgba(255,135,46,0.80);
    border-radius: 50px 50px 0px 0px;
    box-shadow: 0px 4px 0px 0px rgba(255,255,255,0.50) inset; 
    backdrop-filter: blur(6px);
    p {
        font-size: 22px;
        font-family: $font-family;
        font-weight: 400;
        color: #ffffff;
        line-height: 44px;
        width: $width;
        margin: $margin;
        margin-top: 40px;
    }
}
.upgrade-box-common {
    position: relative;
    // background: #ffffff;
    padding-top: 62px;
    h3 {
        font-size: 40px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 52px;
        letter-spacing: 4px;
        margin: 0;
    }
    span {
        display: inline-block;
    }
    .high-box-arrow-left {
        background: url('../../assets/images/upgrade_icon2.png') no-repeat;
        width: 40px;
		height: 24px;
		background-size: 100% 100%;
    }
    .high-box-arrow-right {
        background: url('../../assets/images/upgrade_icon1.png') no-repeat;
        width: 40px;
		height: 24px;
		background-size: 100% 100%;
    }
}
.upgrade-box-common1 {
    padding-top: 62px;
    box-sizing: border-box;
    h3 {
        color: #333333;
    }
}
.upgrade-box-tips-bg {
    width: 1200px;
	height: 601px;
	background: rgba(255,255,255,0.90);
	border-radius: 40px;
	box-shadow: 0px 4px 24px 0px rgba(36,100,91,0.12); 
	backdrop-filter: blur(6px);
	margin: 0 auto;
    background-clip: content-box, padding-box;
    background-image: linear-gradient(180deg, #c0e682, #7ed070);
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 62px;
     .upgrade-box-tips-list {
     	width: calc(100% - 12px)!important;
     	height: calc(100% - 12px)!important;
        background: #fff!important;
        border-radius: 40px;
     }
    .upgrade-box-tips-time {
        width: $width;
        margin: $margin;
        position: relative;
        top: 196px;
        text-align: center;
    }
    .upgrade-box-tips-line {
        display: inline-block;
        width: $width;
        height: 10px;
        border-top:  2px dashed #e1e4eb;
    }
    .upgrade-box-tips-arrow {
        display: inline-block;
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-left: 16px solid #ffbe62;
        border-bottom: 8px solid transparent;
        position: absolute;
        right: 0;
        z-index: 99;
        top: -5px;
    }
    .upgrade-box-tips-list {
        width: $width;
        margin: $margin;
    }
    .upgrade-box-tips {
        position: relative;
        top: 106px;
        .upgrade-box-tips-item-common1 {
            margin-left: -56px;
            position: relative;
            background: url('../../assets/images/upgrade_img1.png') no-repeat;
            .upgrade-box-tips-line1 {
                position: relative;
                left: 94px;
            }
            .upgrade-box-tips-content {
            	padding-top: 28px;
            }
        }
        .upgrade-box-tips-item2 {
            margin-left: 50px;
        }
        .upgrade-box-tips-item3 {
           margin-top: 86px;
    		margin-left: -168px;
        }
        .upgrade-box-tips-item4 {
            margin-left: -6px;
        }
        .upgrade-box-tips-item5 {
            margin-left: -154px;
            margin-top: 86px;
        }
        .upgrade-box-tips-item6 {
            margin-left: -18px;
        }
        .upgrade-box-tips-item7 {
            margin-left: -140px;
            margin-top: 86px;
        }
        .upgrade-box-tips-item-common {
            position: relative;
            top: -132px;
            background: url('../../assets/images/upgrade_img2.png') no-repeat;
            .upgrade-box-tips-content {
            	padding-top: 16px;
            }
        }
        .upgrade-box-tips-content {
           	width: 264px;
			height: 147px;
            background-size: 100%;
            padding: 14px;
            box-sizing: border-box;
            font-family: $font-family;
            text-align: justify;
            color: #332e2c;
            font-size: 16px;
            font-weight: 400;
            box-sizing: border-box;                
            span {
                display: inline-block;
                margin-bottom: 8px;
	            font-size: 24px;
	            line-height: 32px;
            	font-weight: 700;
            	color: #009374;
            }
        }
    }
}
.upgrade-box-tips-bg-diff {
	.upgrade-box-tips-item2 {
		margin-left: 140px!important;
	}
	.upgrade-box-tips-item1 {
		margin-left: -20px!important;
	}
	.upgrade-box-tips-item3 {
	    margin-left: -40px!important;
	}
	.upgrade-box-tips-item5 {
		margin-left: -50px!important;
	}
}
.upgrade-box-school {
    background: url('../../assets/images/upgrade_school_bg.png') no-repeat;
    background-size: cover;
    padding-bottom: 46px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 0;
    h3 {
    	color: #332e2c;
    }
    .upgrade-box-school-infor {
        margin: $margin;
        padding: 0 5%;
        margin-top: 64px;
        min-width: $width;
        max-width: 1660px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        .upgrade-box-school-input {
            width: $width;
            margin: $margin;
			border: 1px solid #e1e4eb;
			border-radius: 8px;
			border: 1px solid #e1e4eb;
			border-radius: 8px;
			::v-deep input {
				background: rgba(47,54,53,0.05);
            	border: none;
            	height: 64px!important;
				box-sizing: border-box;
				padding: 20px;
			}
			::v-deep .el-input-group__append {
				border: none;
				background: rgba(47,54,53,0.05);
			}
        }
        .upgrade-box-school-content {
        	width: $width;
            margin: $margin;
            margin-top: 56px;
        }
        .upgrade-box-school-item {
			background: rgba(47,54,53,0.05);
			border: 1px solid #e1e4eb;
			border-radius: 8px;
			height: 88px;
			margin-bottom: 24px;
			display: flex;
			align-items: center;
			padding: 0 16px;
			color: #2c3331;
			font-size: 20px;
			cursor: pointer;
			img {
				width: 56px;
				height: 56px;
				margin-right: 12px;
				border-radius: 50%;
			}
        }
        .upgrade-box-school-item:hover {
        	color: $common-color;
        	background: #fff7f3;
			border: 1px solid $common-color;
        }
        .upgrade-box-school-input-btns {
            text-align: right;
            button {
                width: 76px;
                height: 44px;
                background: #ffffff;
                border: 1px solid #c4c7cc;
                border-radius: 8px;
                font-size: 16px;
                color: #5e6166;
                margin: 0!important;
            }
            .upgrade-box-school-input-confirm {
                background: linear-gradient(90deg,#ffa94a, #ff913c);
                border-color: transparent;
                color: #ffffff;
                margin-left: 16px!important;
            }
        }
    }
}
.upgrade-box-question {
    background: url('../../assets/images/upgrade_question_bg.png');
    min-height: 760px;
    width: 100%;
    background-position: top;
    .upgrade-box-question-list {
        width: $width;
        margin: $margin;
    }
     h3 {
    	color: #ffffff;
    }
}
.upgrade-box-nan {
    width: 100%;
    height: 1011px;
    background: url('../../assets/images/upgrade_nan_bg.png');
    position: relative;
    .upgrade-box-you-title {
        color: #d1e1db;
    }
    img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 64px;
    }
    .upgrade-box-nan-item {
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(6px);
        color: #2c3331;
        font-size: 24px;
        font-weight: 400;
        margin: $margin;
        padding: 0 25px;
        text-align: center;
        line-height: 36px;
        width: 296px;
        height: 114px;
        background: #ffffff;
        border: 2px solid #b0d6b7;
        border-radius: 20px;
        box-shadow: 0px 0px 20px 0px rgba(0,153,28,0.11); 
    }
    .upgrade-box-nan-list {
        width: 900px;
        margin: $margin;
        margin-bottom: 164px;
    }
}
.upgrade-box-order {
    @include gwidth;
    width: 1200px;
    height: 398px;
    background: rgba(255,255,255,0.20);
    border-radius: 20px;
    box-shadow: 0px 8px 20px 0px rgba(216,92,0,0.16), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(6px);
    padding: 47px 0 47px 80px;
    margin-top: 40px;
    position: relative;
    margin-bottom: 28px;
    .upgrade-box-order-title {
        font-size: 36px;
        font-family: 'zihun443hao';
        color: #ffffff;
    }
    .el-col-9 {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        .upgrade-box-order-img {
            width: 200px;
            height: 200px;
            background: #ffffff;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 16px;

        }

        p {
            font-size: 24px;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            line-height: 33px;
            margin: 0;
            margin-top: 8px;
        }
    }
}
.upgrade-box-service-diff {
    .upgrade-box-order {
        background: linear-gradient(180deg,#ff9e4a, $common-color);
        height: 255px;
        border-radius: 20px;
        box-shadow: 0px 8px 30px 0px rgba(255,97,26,0.38);
        margin-top: -40px;
        img {
            position: absolute;
            top:0;
            right: 0;
            margin: 0;
        }
        .upgrade-box-order-desc {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
            margin-left: 24px;
        }
    }
}
 .no-data-box {
    // position: relative;
    // top: 90px;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // text-align: center;
    margin-top: 100px;
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        // text-align: center;
        color: #666666;
        margin-left: 14px;
    }
}
</style>